/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { Slide, Grid, FormControl, Input, Button, Dialog, DialogTitle, Typography, IconButton, Box, useMediaQuery, DialogContent, DialogActions, Paper, Zoom } from '@mui/material';
import RegistroPacientes from "../RegistroPacientes";
import Close from '@mui/icons-material/CloseOutlined'
import firebase from '../../services/firebase';
import './login.css';
import ReactPlayer from 'react-player';
import { useHistory } from "react-router-dom";
import env from '@beam-australia/react-env'
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { setToken, setGlobalUser } from '../../redux/session';
import { app, socketApp, socket } from '../../services/index'; // importa también socketApp y socket
import { updateCatalogs } from '../../redux/catalogs';
import { catalogs } from '../../repositories';
import defaultCatalogs from '../../constants/defaultCatalogs.json';
import { useTheme } from "@mui/styles";
import Lottie from "react-lottie-player";
import lottieJson from './loading.json';
import lottieJsonPortlad from './loading-portland.json';
import EditableModel from "../EditableModel.js";
import CatalogsIconButton from "../customForms/CatalogsIconButton";
import { usuarios } from "../../constants/models";
const initialState = {
    registroDisplay: false,
    loading: false,
    result: null,
    optionsModal: false,
    loginOk: false,
    notification: null
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const HS = '1103760000003C0000003C0000000000000000000000000000000000000000000000000000177003E803E803E803E800000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000007294';

const getErrorText = (error) => {
    if (!error) return 'Verifica tu conexión a internet.';
    if (typeof error === 'string') return error;

    const rawMessage =
        error?.message ||
        error?.data?.message ||
        error?.errors?.[0]?.message ||
        error?.errors?.message ||
        error?.error ||
        null;

    const statusCode = Number(
        error?.code ??
        error?.statusCode ??
        error?.data?.code ??
        error?.data?.statusCode
    );
    const normalized = `${rawMessage || ''}`.toLowerCase().trim();

    if (
        statusCode === 401 ||
        normalized.includes('not authenticated') ||
        normalized.includes('invalid login') ||
        normalized.includes('invalid password') ||
        normalized.includes('invalid email') ||
        normalized.includes('invalid credentials') ||
        normalized.includes('usuario o contraseña') ||
        normalized.includes('correo o contraseña')
    ) {
        return 'Correo o contraseña incorrectos.';
    }

    if (
        statusCode === 429 ||
        normalized.includes('too many requests') ||
        normalized.includes('rate limit') ||
        normalized.includes('demasiados intentos')
    ) {
        return 'Demasiados intentos de inicio de sesión. Intenta de nuevo en unos minutos.';
    }

    if (
        statusCode === 403 ||
        normalized.includes('forbidden') ||
        normalized.includes('permiso denegado') ||
        normalized.includes('access denied')
    ) {
        return 'No tienes permisos para iniciar sesión con esta cuenta.';
    }

    if (
        statusCode >= 500 ||
        normalized.includes('internal server error') ||
        normalized.includes('service unavailable') ||
        normalized.includes('gateway timeout')
    ) {
        return 'El servidor no pudo procesar el inicio de sesión. Intenta de nuevo más tarde.';
    }

    if (
        normalized.includes('network error') ||
        normalized.includes('failed to fetch') ||
        normalized.includes('load failed') ||
        normalized.includes('timeout') ||
        normalized.includes('offline')
    ) {
        return 'No fue posible conectarse al servidor. Verifica tu conexión a internet.';
    }

    if (rawMessage) return `${rawMessage}`;

    try {
        return JSON.stringify(error);
    } catch (e) {
        return 'Ocurrió un error al iniciar sesión.';
    }
};

function Login(props) {
    const user = useSelector((state) => state.session.globalUser);
    const [intro, setIntro] = useState(!user);
    const [open, setopen] = useState(props.open)
    const dispatch = useDispatch();
    const [play, setPlay] = useState(false)
    const [state, setState] = useState(initialState)
    const theme = useTheme();
    const history = useHistory()
    // console.log('history', history.location.pathname);
    useEffect(() => {
        setopen(props.open);
    }, [props.open])
    useEffect(() => {

    }, [])
    function renderInputs() {
        const fields = getInputs()
        const regExp = new RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)
        const valEmail = regExp.test(fields.email)
        return (
            <Grid padding={2}>

                <FormControl fullWidth>
                    <Input
                        key={fields.email.fieldid}
                        id={fields.email.fieldid}
                        field={fields.email.key}
                        name={fields.email.fieldid}
                        readOnly={fields.email.readOnly || false}
                        label={fields.email.vc_name}
                        type={fields.email.type}
                        disableUnderline
                        fullWidth
                        defaultValue={''}
                        placeholder={fields.email.name}
                        inputProps={{
                            placeholder: fields.email.name,
                            style: {
                                padding: '9px 18px',
                                borderRadius: 5,
                                height: 25,
                                border: '1px solid gray'
                            }
                        }}
                        errormessage={!valEmail ? 'E-mail no valido' : ''}
                    />
                </FormControl>
                <FormControl fullWidth>
                    <Input
                        key={fields.password.fieldid}
                        id={fields.password.fieldid}
                        field={fields.password.key}
                        name={fields.password.fieldid}
                        readOnly={fields.password.readOnly || false}
                        label={fields.password.vc_name}
                        type={fields.password.type}
                        disableUnderline
                        fullWidth
                        defaultValue={''}
                        margin='dense'
                        placeholder={fields.password.name}
                        inputProps={{
                            placeholder: fields.password.name,
                            style: {
                                padding: '9px 18px',
                                borderRadius: 5,
                                height: 25,
                                border: '1px solid gray'
                            }
                        }}
                        style={{ marginTop: 16, minWidth: 300 }}
                    />
                    <Typography color='primary' component={'a'} marginTop={1} onClick={recuperarCuenta}>
                        {'¿Olvidaste tu contraseña?'}
                    </Typography>
                    <div className="acciones" style={{ margin: '16px 0px' }}>
                        <Button
                            fullWidth
                            variant='outlined'
                            onClick={onButtonClick}
                        >
                            {'Iniciar sesión'}
                        </Button>

                    </div>
                </FormControl>
                <Grid item xs style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <CatalogsIconButton variant='text' title={'Crear usuario'} mode="title" model={usuarios} />
                    <Button color='primary' component={'a'} marginRight={1} onClick={() => { setState({ ...state, registroDisplay: true }); }}>
                        {'Comunicate con Total Ground'}
                    </Button>
                </Grid>
                <Box p={1} position={'absolute'} bottom={0} right={0}>
                    <Typography fontSize={10} style={{ color: 'gray', textAlign: 'right' }}>
                        {`Version: ${process.env.REACT_APP_VERSION || 'N/D'}`}
                    </Typography>
                </Box>
            </Grid>
        )
    }

    function renderUsuarioRegistro() {
        return (
            <RegistroPacientes
                registroDisplay={state.registroDisplay}
                backButton={() => {
                    setState({ ...state, registroDisplay: false })
                }}
            />
        )
    }

    function recuperarCuenta() {
        let formData = {};
        Object.values(getInputs()).map((field, index) => {
            const renderField = document.getElementById(field.key)
            if (renderField.value) {
                formData[field.key] = renderField.value
            }
        })
        const regExp = new RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)
        const valEmail = regExp.test((formData.emailLogin || '').toLowerCase())
        // auth().sendPasswordResetEmail(formData.email,{url:`https://app.thin-k.mx/#/restablecer?email=${formData.email}`}).catch(function (error) {

        // 	console.log('respuesta a firebase', e)
        // })

        if (formData.emailLogin && valEmail) {
            const body = {
                email: formData.emailLogin
            };
            setState({ ...state, result: null, loading: true });
            window.$.ajax({
                url: `${env('REACT_APP_API_URL')}/app/resetPasswordMail/${body.email}`,
                data: body,
                method: 'GET'
            }).then((data, status, xhr, error) => {
                if (data.message) {
                    setState({ ...state, result: null, optionsModal: false, loading: false, notification: { title: data.message, message: '' } });
                }
            }).fail((data, status, xhr, error) => {
                setState({ ...state, result: null, optionsModal: false, loading: false, notification: { title: '!Ups¡', message: error || 'comprueba tu conexión a internet' } });
            });
        } else {
            setState({ ...state, result: null, optionsModal: false, loading: false, notification: { title: 'Ingresa un E-Mail valido.' } });
        }
    }
    function renderUsuarioRecuperacion() {
        return (
            <Dialog open={!!(state.email && state.vc_token && state.recoveryModal)} size='mini' basic>
                {/* <RecuperacionUsuarioModal
					email={state.email}
					vc_token={state.vc_token}
					backButton={() => {
						setState({...state, registroDisplay: false, recoveryModal: false });
					}}
				/> */}
            </Dialog>
        )
    }

    // ----------------------
    // ------  methods ------
    // ----------------------

    const loginService = async (formData) => {
        try {
            if (app.authentication?.authenticated) await app.logout();

            const response = await app.authenticate({
                strategy: 'local',
                email: formData.email,
                password: formData.password
            });
            console.log('autentication', response)
            setState({ ...state, result: null, loading: false });

            const authData = await app.get('authentication'); // aquí viene accessToken + usuario
            const token = authData?.accessToken;

            // ✅ Guardas user y token como ya lo haces
            const res = await app.service('users-roles').find({
                query: { $and: [{ id_usuario: authData?.usuario?.id }] }
            });

            dispatch(setGlobalUser({ ...authData.usuario, roles: res.data }));
            dispatch(setToken(token));

            // ✅ Ahora: SOCKET CONNECT + AUTH con JWT
            if (token) {
                try {
                    // 1) conecta socket (como autoConnect=false)
                    if (!socket.connected) socket.connect();

                    // 2) setea token al cliente feathers socket
                    socketApp.authentication?.setAccessToken?.(token);

                    // 3) autentica por jwt en socket
                    await socketApp.authenticate({
                        strategy: 'jwt',
                        accessToken: token,
                    });

                    console.log('[socket] authenticated OK');
                } catch (e) {
                    console.log('[socket] auth failed', e);
                    // no forzaría logout aquí; puede ser que el socket server esté caído pero REST funcione
                }
            }

            // ... catálogos como ya lo haces
            Object.values(defaultCatalogs).forEach((item) => {
                catalogs.initCatalogs(
                    { name: item.name, service: item.name, data: item.data, lastUpdate: item.lastUpdate },
                    (catalog) => dispatch(updateCatalogs(catalog))
                );
            });

        } catch (error) {
            console.error('Error authenticating!', error);
            setState({
                ...state,
                result: null,
                optionsModal: false,
                loading: false,
                error: {
                    title: '¡Ups!',
                    message: getErrorText(error),
                }
            });
        }
    };

    async function onButtonClick() {
        if (state.optionsModal) {
            setState({ ...state, result: null, optionsModal: false, loading: false });
        } else {
            let formData = {};
            Object.values(getInputs()).map((field, index) => {
                console.log('key', field.key)
                const renderField = document.getElementById(field.key)
                if (renderField.value) {
                    formData[field.key.replace('Login', '')] = renderField.value
                }
            })
            console.log('form', formData)
            if (!formData.email || !formData.password) {
                setState({ ...state, result: null, optionsModal: false, loading: false, notification: { title: '¡Ups!', message: formData.Message || 'Verifica los campos.' } });
            } else if (!state.optionsModal) {
                const body = {
                    ...formData,
                };
                setState({ ...state, result: null, loading: true });
                try {
                    await loginService(formData);
                } catch (error) {
                    console.log('error', error)
                    setState({
                        ...state,
                        result: null,
                        optionsModal: false,
                        loading: false,
                        error: {
                            title: '¡Ups!',
                            message: getErrorText(error),
                        }
                    });
                }
            }
        }
    }

    function getInputs() {
        const fields = {
            email: {
                key: 'emailLogin',
                fieldid: 'emailLogin',
                required: true,
                name: 'E-mail',
                fullWidth: true,
                label: 'E-mail',
                type: 'email'
            },
            password: {
                key: 'passwordLogin',
                fieldid: 'passwordLogin',
                required: true,
                name: 'Contraseña',
                fullWidth: true,
                label: 'Contraseña',
                type: 'password'
            }
        };
        return fields;
    }

    function fowardSelector(result, stateEdit) {
        const state = stateEdit;
        if (result.instituciones.length > 0 && state.institution == null) {
            if (result.instituciones.length === 1) {
                state.institution = result.instituciones[0];
            }
        }
        if (state.institution != null) {
            if (state.institution.roles.length > 0 && state.rol == null) {
                if (state.institution.roles.length === 1) {
                    state.rol = state.institution.roles[0];
                }
            }
            if (state.institution.agendas.length > 0 && state.agenda == null) {
                if (state.institution.agendas.length === 1) {
                    state.agenda = state.institution.agendas[0];
                }
            }
        }

        if (state.institution && state.rol && state.agenda) {
            const resultFinal = {
                ...result,
                ...state
            };
            setState({ ...state, optionsModal: false }, () => { props.login(resultFinal); });
        } else if (result.instituciones.length === 0) {
            const resultFinal = {
                ...result,
                ...state
            };
            setState({ ...state, optionsModal: false }, () => { props.loginWithOutInstitution(resultFinal); });
        } else {
            setState({ ...state, result, optionsModal: true, loading: false });
        }
    }

    function selected(optionsSelected) {
        const result = {
            ...state.result,
            ...optionsSelected
        };
        setState({ ...state, optionsModal: false });
        dispatch({ type: 'SET_USER', payload: { ...result, selected: result.paciente || null } });

    }
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    return (
        <Dialog
            open={open && history?.location?.pathname !== '/video-call'}
            fullScreen={!isMd || intro}
            TransitionComponent={Transition}
            transitionDuration={500}
            BackdropProps={{ style: { backgroundColor: 'black' } }}
            onClose={() => {
                console.log('entro a home')
                history.push('/')
            }}
            onAnimationEnd={() => {
                if (!open) {
                    console.log('entro a home')
                    history.push('/')
                }
            }}
            PaperComponent={Paper}
            PaperProps={{ onKeyDown: (e) => e.keyCode === 13 && onButtonClick() }}
        >
            <DialogTitle color='primary'>
                {/* {'Iniciar sesión'} */}
                <Box p={2} style={{ justifyContent: 'center', display: 'flex' }}>
                    <img
                        width={'50%'}
                        style={{ borderRadius: '50%', boxShadow: '0px 0px 5px 5px rgba(50,50,50,0.9)' }}
                        src="assets/images/tgone-logo.png"
                        alt=""
                    />
                </Box>
            </DialogTitle>
            {renderInputs()}
            <Dialog
                open={!!state.error}
            >
                <DialogTitle>
                    {state.error?.title || ''}
                </DialogTitle>
                <DialogContent>
                    {state.error?.message || ''}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setState({ ...state, error: null })}
                    >
                        {'Ok'}
                    </Button>
                </DialogActions>
            </Dialog>
            {
                intro &&
                <Box style={{ position: 'absolute', width: '100%', top: 0, left: 0, height: '100vh' }}>
                    {/* <Loading /> */}
                    {/* <Zoom in={intro} style={{width: '100%', height: '100%'}}> */}
                    <Lottie
                        loop={false}
                        onComplete={() => setIntro(false)}
                        animationData={isMd ? lottieJson : lottieJsonPortlad}
                        play
                        style={{ height: '100%' }}
                    />
                    {/* </Zoom> */}
                </Box>
            }
        </Dialog >
    )
}
Login.propTypes = {

}

export default Login
